const DocumentContants = {
  ADD_DOCUMENT_SUCCESS: "ADD_DOCUMENT_SUCCESS",
  ADD_DOCUMENT_FAILURE: "ADD_DOCUMENT_FAILURE",
  GET_DOCUMENTS_SUCCESS: "GET_DOCUMENTS_SUCCESS",
  GET_DOCUMENTS_FAILURE: "GET_DOCUMENTS_FAILURE",

  GET_EQUIPMENTDETAIL_SUCCESS: "GET_EQUIPMENTDETAIL_SUCCESS",
  GET_EQUIPMENTDETAIL_FAILURE: "GET_EQUIPMENTDETAIL_FAILURE",
  UPDATE_EQUIPMENT_SUCCESS: "UPDATE_EQUIPMENT_SUCCESS",
  UPDATE_EQUIPMENT_FAILURE: "UPDATE_EQUIPMENT_FAILURE",

  GET_AUFTRAGSDETAIL_SUCCESS: "GET_AUFTRAGSDETAIL_SUCCESS",
  GET_AUFTRAGSDETAIL_FAILURE: "GET_AUFTRAGSDETAIL_FAILURE",
  GET_RUECKMELDUNGVORLAGE_SUCCESS: "GET_RUECKMELDUNGVORLAGE_SUCCESS",
  GET_RUECKMELDUNGVORLAGE_FAILURE: "GET_RUECKMELDUNGVORLAGE_FAILURE",
  GET_DOCUMENTASBYTE_SUCCESS: "GET_DOCUMENTASBYTE_SUCCESS",
  GET_DOCUMENTASBYTE_FAILURE: "GET_DOCUMENTASBYTE_FAILURE",

  GET_BILD_SUCCESS: "GET_BILD_SUCCESS",
  GET_BILD_FAILURE: "GET_BILD_FAILURE",

  DELETE_DOCUMENT_SUCCESS: "DELETE_DOCUMENT_SUCCESS",
  DELETE_DOCUMENT_FAILURE: "DELETE_DOCUMENT_FAILURE",

  GENERIERT_BETR_SUCCESS: "GENERIERT_BETR_SUCCESS",
  GENERIERT_BETR_FAILURE: "GENERIERT_BETR_FAILURE",

  GENERATE_ACCEPTANCE_PROTOCOL_SUCCESS: "GENERATE_ACCEPTANCE_PROTOCOL_SUCCESS",
  GENERATE_ACCEPTANCE_PROTOCOL_FAILURE: "GENERATE_ACCEPTANCE_PROTOCOL_FAILURE",

  CHECK_FILEEXISTS_SUCCESS: "CHECK_FILEEXISTS_SUCCESS",
  CHECK_FILEEXISTS_FAILURE: "CHECK_FILEEXISTS_FAILURE",
  GENERIERT_PRUEFBERICHT_SUCCESS: "GENERIERT_PRUEFBERICHT_SUCCESS",
  GENERIERT_PRUEFBERICHT_FAILURE: "GENERIERT_PRUEFBERICHT_FAILURE",
  GET_INSPECTION_IMAGE_SUCCESS: "GET_INSPECTION_IMAGE_SUCCESS",
  GET_INSPECTION_IMAGE_FAILURE: "GET_INSPECTION_IMAGE_FAILURE",
  GET_ORDER_STATUS_SUCCESS: "GET_ORDER_STATUS_SUCCESS",
  GET_ORDER_STATUS_FAILURE: "GET_ORDER_STATUS_FAILURE",

  GET_AUFTRAGSDETAILBYID_SUCCESS: "GET_AUFTRAGSDETAILBYID_SUCCESS",
  GET_AUFTRAGSDETAILBYID_FAILURE: "GET_AUFTRAGSDETAILBYID_FAILURE",

  GET_EQUIP_DETAIL_OVERVIEW_SUCCESS: "GET_EQUIP_DETAIL_OVERVIEW_SUCCESS",
  GET_EQUIP_DETAIL_OVERVIEW_FAILURE: "GET_EQUIP_DETAIL_OVERVIEW_FAILURE",
};
export default DocumentContants;
